import { Box, Image, Text } from '@chakra-ui/react';
import { ChatMessageStatus } from 'enums/modules/chat/chatMessageStatus';
import { Color } from 'presentation/theme/colorScheme';
import { FC } from 'react';
import ChatMessageFile from './ChatMessageFile';
import ChatMessageStatusRow from './ChatMessageStatus';
import messageBubbleTriangle from 'assets/img/polygon/message-bubble-triangle.svg';

interface Props {
  text: string | null;
  isSelfMessage: boolean;
  files: ChatMessageFile[];
  createdAt: Date;
  status: ChatMessageStatus;
  authorName?: string;
  showTrianglePolygon: boolean;
}

const ChatMessageBubble: FC<Props> = ({
  text,
  isSelfMessage,
  files,
  createdAt,
  status,
  authorName,
  showTrianglePolygon,
}) => {
  return (
    <Box pos="relative" maxW="100%" minW={0}>
      <Box
        px="20px"
        py="10px"
        borderRadius="16px"
        minW="160px"
        maxW="320px"
        backgroundColor={Color.Shade100}
      >
        {authorName && (
          <Text
            fontWeight={600}
            mb="10px"
            overflowWrap="anywhere"
            wordBreak="break-word"
          >
            {authorName}
          </Text>
        )}
        {files.length > 0 && (
          <Box>
            {files.map((file, index) => (
              <ChatMessageFile key={index} {...file} />
            ))}
          </Box>
        )}
        {text && (
          <Text
            mb="10px"
            whiteSpace="pre-line"
            overflowWrap="anywhere"
            wordBreak="break-word"
          >
            {text}
          </Text>
        )}
        <ChatMessageStatusRow
          createdAt={createdAt}
          isSelfMessage={isSelfMessage}
          status={status}
        />
      </Box>
      {showTrianglePolygon && (
        <Image
          src={messageBubbleTriangle}
          pos="absolute"
          w="30px"
          bottom="0"
          right={isSelfMessage ? '-10px' : ''}
          left={isSelfMessage ? '' : '-10px'}
        />
      )}
    </Box>
  );
};

export default ChatMessageBubble;
